import type {
  APIRequestBody,
  APIRequestQueryParams,
  APIResponse,
} from './base-fetch';
import { get, post } from './base-fetch';

type GenAiRequestHistoryParams = APIRequestQueryParams<'/api/v4/genai-request'>;

export type GenAiRequest = APIResponse<'/api/v4/genai-request'>[number];

export type GenAiRequestHistory =
  APIResponse<'/api/v4/genai-request/{requestId}'>;

export type GenAiRequestHistoryResult = GenAiRequestHistory['result'][number];

export type GenAiRequestHistoryRound = GenAiRequestHistory['rounds'][number];

export type CreateExploreRoundPayload =
  APIRequestBody<'/api/v4/genai-request/{requestId}/rounds'>;

export type CreateExploreRoundResponse =
  APIResponse<'/api/v4/genai-request/{requestId}/rounds'>;

export const MAX_EXPLORE_ROUNDS = 10;

export const fetchGenAiRequestHistory = async (
  params: GenAiRequestHistoryParams,
) => get<GenAiRequest[]>('/v4/genai-request', { params });

export const fetchGenAiRequest = async (requestId: string) =>
  get<GenAiRequestHistory>(`/v4/genai-request/${requestId}`);

export const createExploreRound = async (
  requestId: string,
  data: CreateExploreRoundPayload,
): Promise<CreateExploreRoundResponse> =>
  post<CreateExploreRoundResponse, CreateExploreRoundPayload>(
    `/v4/genai-request/${requestId}/rounds`,
    data,
  );
